.fieldset {
  min-width: 0;
  margin: 0;
  padding: var(--space-4);
  border: 1px solid var(--color-surface-tinted);
  border-radius: var(--radius-lg);
  background: var(--color-surface-raised);
}

.fieldset legend {
  padding-inline: var(--space-2);
  font-weight: 800;
}

.fieldset p {
  margin: 0 0 var(--space-3);
  color: var(--color-text-secondary);
  font-size: 0.875rem;
}

.fieldset[data-compact] {
  padding: 0;
  border: 0;
  background: transparent;
}

.options {
  display: grid;
  gap: var(--space-2);
}

.option {
  position: relative;
  display: grid;
  min-height: 3.75rem;
  align-items: center;
  gap: var(--space-3);
  grid-template-columns: 2.75rem minmax(0, 1fr) 1.5rem;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--color-surface-tinted);
  border-radius: var(--radius-lg);
  color: var(--color-text-primary);
  background: var(--color-surface-subtle);
  font: inherit;
  font-weight: 750;
  text-align: left;
  cursor: pointer;
  box-shadow: var(--shadow-control);
}

.option[data-selected] {
  border-color: var(--color-brand);
  background: color-mix(in srgb, var(--color-brand) 10%, var(--color-surface-raised));
}

.option[data-target] {
  border-color: var(--color-brand);
  box-shadow: 0 0 0 0.1875rem color-mix(in srgb, var(--color-brand) 20%, transparent);
}

.icon {
  display: grid;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: var(--radius-md);
  color: var(--color-on-color-card);
  background: var(--color-card-blue);
  place-items: center;
}

.icon img {
  width: 90%;
  height: 90%;
  object-fit: contain;
}

.option[data-category='series'] .icon {
  background: var(--color-card-pink);
}

.option[data-category='games'] .icon {
  background: var(--color-card-green);
}

.option[data-category='anime'] .icon {
  background: var(--color-play-party);
}

.label {
  min-width: 0;
  font-size: 0.9375rem;
}

.check {
  display: grid;
  width: 1.5rem;
  height: 1.5rem;
  border: 0.125rem solid var(--color-text-secondary);
  border-radius: 0.4375rem;
  color: transparent;
  background: var(--color-surface-raised);
  place-items: center;
}

.option[data-selected] .check {
  border-color: var(--color-brand);
  color: var(--color-on-brand);
  background: var(--color-brand);
}

.option:focus-visible {
  border-color: var(--color-focus);
  outline: 0.125rem solid var(--color-focus);
  outline-offset: 0.125rem;
}

[data-mantine-color-scheme='dark'] .option[data-selected] .check {
  border-color: var(--color-accent);
  color: var(--color-on-accent);
  background: var(--color-accent);
}

.option:disabled {
  cursor: not-allowed;
}

@media (hover: hover) and (pointer: fine) {
  .option:hover {
    border-color: var(--color-brand);
  }
}
